<template>
  <div class="modal-overflow">
    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label>First Name</label>
          <el-input type="text"
                 name="firstName"
                 data-vv-as="first name"
                 placeholder="First Name"
                 :clearable="true"
                 v-validate="modelValidations.firstName"
                 v-model="contact.firstName" />
          <small class="text-danger" v-show="errors.has('firstName')">
            {{ getError('firstName') }}
          </small>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>Last Name</label>
          <el-input type="text"
                 name="lastName"
                 placeholder="Last Name"
                 data-vv-as="last name"
                 :clearable="true"
                 v-validate="modelValidations.lastName"
                 v-model="contact.lastName" />
          <small class="text-danger" v-show="errors.has('lastName')">
            {{ getError('lastName') }}
          </small>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>Title</label>
          <el-input type="text"
                 name="title"
                 placeholder="Title"
                 data-vv-as="title"
                 :clearable="true"
                 v-model="contact.title" />
          <small class="text-danger" v-show="errors.has('title')">
            {{ getError('title') }}
          </small>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label>Work Phone</label>
          <el-input type="text"
                 name="workPhone"
                 placeholder="Work Phone"
                 data-vv-as="work phone"
                 :clearable="true"
                 v-model="contact.workPhone" />
          <small class="text-danger" v-show="errors.has('workPhone')">
            {{ getError('workPhone') }}
          </small>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>Mobile Phone</label>
          <el-input type="text"
                 name="mobilePhone"
                 placeholder="Mobile Phone"
                 data-vv-as="mobile phone"
                 :clearable="true"
                 v-model="contact.mobilePhone" />
          <small class="text-danger" v-show="errors.has('mobilePhone')">
            {{ getError('mobilePhone') }}
          </small>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>Location</label>
          <el-select class="select"
                     size="large"
                     name="addressId"
                     data-vv-as="location"
                     placeholder="Location"
                     v-model="contact.addressId">
            <el-option v-for="option in addresses"
                       class="select"
                       :value="option.value"
                       :label="option.label"
                       :key="option.label" />
          </el-select>
          <small class="text-danger" v-show="errors.has('addressId')">
            {{ getError('addressId') }}
          </small>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <h5 style="margin-top: 12px">
          Email
          <el-tooltip effect="dark" content="To treat this contact as a distribution list, enter more than one email address" placement="top">
            <img class="icon-help" src="static/img/icon-help.png"/>
          </el-tooltip>
        </h5>
        <div class="row">
          <div class="col-md-10">
            <el-input type="text"
                      name="email"
                      data-vv-as="email"
                      clearable
                      data-vv-validate-on="blur"
                      placeholder="Add Email"
                      @focus="resetValidation"
                      @keyup.enter.native="validateAndAddEmailToContact"
                      v-validate="modelValidations.email"
                      v-model="addEmail" />
            <small class="text-danger" v-show="errors.has('email')">
              {{ getError('email') }}
            </small>
          </div>
          <div class="col-md-2">
            <button type="button" :disabled="invalidEmail" @click="addEmailToContact" class="btn btn-fill btn-info el-icon-plus" style="padding: 10px; margin-top: 4px;"></button>
          </div>
        </div>
        <el-table class="table-striped"
                  :data="contact.emails"
                  border
                  :show-header="false"
                  style="width: 100%">
          <el-table-column label="Email">
            <template slot-scope="props">
              {{ props.row }}
            </template>
          </el-table-column>
          <el-table-column
            width="60"
            fixed="right"
            label="Actions">
            <template slot-scope="props">
              <div style="text-align: center">
                <p-button type="danger" size="sm" icon @click="removeEmailFromContact(props.row)">
                  <i class="fa fa-times"></i>
                </p-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="col-md-8">
        <h5 style="margin-top: 12px;">Email Preferences</h5>
        <div class="row">
          <div class="col-md-6">
            <h6>Completion Email - Inspections</h6>
            <div class="form-group">
              <p-checkbox v-model="contact.notifications.completion.client" name="completionClient" :disabled=emailPreferencesDisabled>Client</p-checkbox>
              <p-checkbox v-model="contact.notifications.completion.builder" name="completionBuilder" :disabled=emailPreferencesDisabled>Builder</p-checkbox>
            </div>
            <h6>Completion Email - Plan Review</h6>
            <div class="form-group">
              <p-checkbox v-model="contact.notifications.completionPlanReview.client" name="completionPlanReviewClient" :disabled=emailPreferencesDisabled>Client</p-checkbox>
              <p-checkbox v-model="contact.notifications.completionPlanReview.builder" name="completionPlanReviewBuilder" :disabled=emailPreferencesDisabled>Builder</p-checkbox>
            </div>
          </div>
          <div class="col-md-6">
            <h6>Reminder Email - Inspections</h6>
            <div class="form-group">
              <p-checkbox v-model="contact.notifications.reminder.client" name="reminderClient" :disabled=emailPreferencesDisabled>Client</p-checkbox>
              <p-checkbox v-model="contact.notifications.reminder.builder" name="reminderBuilder" :disabled=emailPreferencesDisabled>Builder</p-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12" v-if="canEdit">
        <button type="submit" @click.prevent="validateAndSubmit" :disabled="saveButtonLocked" class="btn btn-fill btn-info btn-wd pull-right">Save</button>
        <div class="form-group form-group-active-label">
          <label class="active-label">Active</label>
          <p-switch v-model="contact.active" type="primary" on-text="YES" off-text="NO"></p-switch>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import {ObjectID} from 'bson'
  import Permissions from 'src/utilities/permissions'
  import {notifyError, notifySuccess, notifyWarning} from 'src/utilities/utils'
  import {CREATED, OK} from 'http-status-codes'
  import _ from 'lodash'

  export default {
    props: ['data'],
    computed: {
      ...mapGetters({
        addresses: 'companies/companyAddressesKvpsForSelect'
      }),
      canEdit() {
        return this.$can('edit', Permissions.COMPANIES)
      },
      emailPreferencesDisabled() {
        return !this.contact.active || (this.contact.emails && this.contact.emails.length === 0)
      },
      invalidEmail() {
        return this.errors.has('email')
      }
    },
    data() {
      return {
        saveButtonLocked: false,
        addEmail: null,
        companyContactSaved: false,
        contact: {
          active: true,
          id: null,
          firstName: null,
          lastName: null,
          name: null,
          title: null,
          emails: null,
          workPhone: null,
          mobilePhone: null,
          addressId: null,
          notifications: {
            completion: {
              client: false,
              builder: false
            },
            completionPlanReview: {
              client: false,
              builder: false
            },
            reminder: {
              client: false,
              builder: false
            }
          }
        },
        modelValidations: {
          firstName: {
            required: true
          },
          lastName: {
            required: true
          },
          email: {
            email: true
          }
        }
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName)
      },
      resetNotifications() {
        this.contact.notifications = {
          completion: {
            client: false,
            builder: false
          },
          completionPlanReview: {
            client: false,
            builder: false
          },
          reminder: {
            client: false,
            builder: false
          }
        }
      },
      addEmailToContact() {
        if (!Array.isArray(this.contact.emails)) {
          this.contact.emails = []
        }
        if (this.contact.emails.includes(this.addEmail)) {
          notifyWarning(this, this.addEmail + ' is already listed')
          return
        } else if (!this.addEmail) {
          notifyWarning(this, 'Please type a valid email address')
          return
        }

        this.contact.emails.push(this.addEmail)
        this.addEmail = null
      },
      removeEmailFromContact(emailToDelete) {
        this.contact.emails = _.filter(this.contact.emails, (email) => email !== emailToDelete)
      },
      resetValidation() {
        this.$validator.reset()
      },
      async validateAndAddEmailToContact() {
        if (await this.$validator.validate('email')) {
          this.addEmailToContact()
        }
      },
      async validateAndSubmit() {
        this.saveButtonLocked = true
        if (await this.$validator.validateAll()) {
          if (this.emailPreferencesDisabled) {
            this.resetNotifications()
          }
          if (_.get(this.data, 'id')) {
            this.$store.commit('companies/companyContactUpdate', this.contact)
          } else {
            this.contact.id = new ObjectID().toString('hex')
            this.contact.name = this.contact.firstName + ' ' + this.contact.lastName
            this.$store.commit('companies/companyContactAdd', this.contact)
          }

          const savePayload = this.$store.get('companies/savePayload', 'companies')
          const response = await this.$store.dispatch('save2', savePayload)

          if (OK === response.status || CREATED === response.status) {
            this.companyContactSaved = true
            notifySuccess(this, 'Contact record updated successfully')
            if (!this.contact.emails || this.contact.emails.length === 0) {
              notifyWarning(this, 'Contact saved without an email address')
            }
            this.$eventHub.$emit('companyContactUpdated', this.contact)

            if (!this.$store.get('companies/edit@id')) {
              this.$store.commit('companies/updateEdit', response.data)
            }
          } else {
            if (_.get(this.data, 'id')) {
              this.$store.commit('companies/companyContactUpdate', this.data)
            } else {
              this.$store.commit('companies/companyContactRemove', this.contact)
            }
            notifyError(this, 'Failed to Update Company Contact', response.errors)
          }
          this.$emit('close')
        }

        this.saveButtonLocked = false
      }
    },
    beforeMount() {
      // contact record only
      if (this.data && this.data.hasOwnProperty('name')) {

        Object.keys(this.contact).forEach(key => {
          if (this.data[key] !== undefined) {
            if (key === 'notifications' && _.isEmpty(this.data['notifications'])) {
              this.resetNotifications()
            } else {
              // https://ats-engineers.atlassian.net/browse/PTRAC-1057
              // Add missing completionPlanReview to contacts that don't have it configured
              if (!_.get(this.data, 'notifications.completionPlanReview')) {
                this.data.notifications.completionPlanReview = {
                  client: false,
                  builder: false
                }
              }
              this.contact[key] = this.data[key]
            }
          }
        })
      }
    },
    destroyed() {
      if (!this.companyContactSaved) {
        this.$eventHub.$emit('noCompanyContactSelected')
      }
    },
    watch: {
      emailPreferencesDisabled: {
        handler: function(emailPreferencesDisabled) {
          if (emailPreferencesDisabled) {
            this.resetNotifications()
          }
        }
      }
    }
  }
</script>
